import React, { useState } from "react";
import { SimpleTable } from "../../ui/SimpleTable/SimpleTable";
import { ConfirmDialog } from "../../ConfirmDialog/ConfirmDialog";

import { Counterparty } from "../../../../../types/api/guide/counterparty.types";
import { useFetchAllCounterparty } from "../../../../../hooks/guide/useFetchAllCounterparty";
import { counterpartyService } from "../../../../../services/guide/counterparty-service";
import { CounterpartyAddModal } from "../../ui/EntityModal/CounterpartyAddModal";
import useAppSnackbar from "../../../../../hooks/useAppSnackbar";

interface ContractorsTableProps {
    title: string;
}

export const ContractorsTable = ({ title }: ContractorsTableProps) => {
    const { data: counterparties, refetch } = useFetchAllCounterparty();
    const { showSuccess, showError, SnackbarComponent } = useAppSnackbar();
    const [toDelete, setToDelete] = useState<Counterparty | null>(null);

    const [openModal, setOpenModal] = useState<{ isOpen: boolean; id?: string }>({
        isOpen: false,
        id: undefined,
    });

    const handleDelete = async (id: string) => {
        try {
            await counterpartyService.delete(id);
            showSuccess("Успешное удаление")
            refetch();
        } catch (e) {
            showError(e.response.data);
            console.log("Ошибка при удалении контрагента");
        }
    };

    return (
        <>
            <SimpleTable<Counterparty>
                title={title}
                columns={[
                    { key: "name", title: "Название" },
                    { key: "company", title: "Организация" },
                ]}
                data={counterparties}
                enableSearchByName
                getRowKey={(r) => r.id}
                getRowActions={(row) => ({
                    onEdit: () => setOpenModal({ isOpen: true, id: row.id }),

                    onDelete: () => setToDelete(row),
                })}
                emptyText="Справочник пуст"
                setOpen={() => setOpenModal({ isOpen: true, id: undefined })}
            />

            <ConfirmDialog
                open={!!toDelete}
                title="Удалить контрагента?"
                description={toDelete ? `Будет удалён: ${toDelete.name}` : undefined}
                onCancel={() => setToDelete(null)}
                onConfirm={() => {
                    if (!toDelete) return;
                    handleDelete(toDelete.id);
                    setToDelete(null);
                }}
            />

            {openModal.isOpen && (
                <CounterpartyAddModal
                    id={openModal.id}
                    onClose={() => setOpenModal({ isOpen: false, id: undefined })}
                    refetchData={refetch}
                />
            )}
            <SnackbarComponent/>
        </>
    );
};
